import * as React from 'react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';

import { ClientListDataService } from 'src/app/crm/clients/list/client-list.data';
import { ClientEditorView } from './client-editor.view';

interface ClientEditorControllerProps {
    value: number | null;
    mode: ControlMode;
    onChanged: (value: ClientSummary | null) => void;
    setBusy(isBusy: boolean);
    label?: string;
    required?: boolean;
    onGetErrorMessage?: () => Promise<ValidationError[]>;
}

export class ClientEditorController extends React.Component<ClientEditorControllerProps, any> {
    protected clientDataService: ClientListDataService;

    constructor(props) {
        super(props);
        this.clientDataService = ClientListDataService.make();
    }

    @autobind
    protected clientQuery(q?: string): Promise<QueryResult<ClientSummary>> {
        return new Promise<QueryResult<ClientSummary>>((resolve, reject) => {
            this.props.setBusy(true);
            this.clientDataService.addFilter('isDeleted', 'eq', false);
            this.clientDataService.addSorting('id', 'asc', true);
            this.clientDataService.searchKeywords = q;
            this.clientDataService.load(query => query)
                .then((items) => {
                    this.props.setBusy(false);
                    resolve({
                        items: items,
                        totalCount: this.clientDataService.count
                    });
                });
        });
    }

    render() {
        return (
            <ClientEditorView
                clientRequest={{ query: this.clientQuery, dataSet: this.clientDataService }}
                onChanged={this.props.onChanged}
                value={this.props.value}
                onGetErrorMessage={this.props.onGetErrorMessage}
                mode={this.props.mode}
                label={this.props.label}
                required={this.props.required} />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/crm/clients/parts/client-editor.controller.tsx